<template>
  <f7-page name="group-home" :page-content="false">
    <f7-navbar v-if="!chatTabActive" :title="group?.name || $t('grouphome.testGroup')" back-link>
      <f7-nav-right>
        <f7-link icon-f7="person_badge_plus" />
      </f7-nav-right>
    </f7-navbar>

    <f7-toolbar
      id="groupTabbar"
      tabbar scrollable
      top
      labels
    >
    <f7-toolbar-pane>
      <f7-link class="fab-close" data-fab=".group-tab-fab" tab-link="#tab-home" f7-icon="" tab-link-active>{{$t("common.home")}}</f7-link>
      <f7-link class="fab-close" data-fab=".group-tab-fab" tab-link="#tab-members" f7-icon="">{{$t("common.members")}}</f7-link>
      <f7-link class="fab-close" data-fab=".group-tab-fab" tab-link="#tab-campaigns">{{$t("common.campaigns")}}</f7-link>
      <f7-link class="fab-close" data-fab=".group-tab-fab" tab-link="#tab-growth">{{$t("common.growth")}}</f7-link>
      <f7-link class="fab-close" data-fab=".group-tab-fab" tab-link="#tab-calendar">{{$t("common.calendar")}}</f7-link>
      <f7-link class="fab-close" data-fab=".group-tab-fab" tab-link="#tab-marketplace">{{$t("marketplace.title")}}</f7-link>
      <f7-link class="fab-close" data-fab=".group-tab-fab" tab-link="#tab-chat">{{$t("common.chat")}}</f7-link>
      <f7-link class="fab-close" data-fab=".group-tab-fab" tab-link="#tab-docs">{{$t("common.documents")}}</f7-link>
   </f7-toolbar-pane>
    </f7-toolbar>

    <f7-tabs id="groupTabs" swipeable>
      <f7-tab id="tab-home" tab-active>
        <GroupHomeTab :group-id="groupId" />
      </f7-tab>
      <f7-tab id="tab-members">
        <MembersTab :group-id="groupId" @open-full-page="navigateToMembers" />
      </f7-tab>
      <f7-tab id="tab-campaigns">
        <AvocashCampaignList :group-id="groupId" />
      </f7-tab>
      <f7-tab id="tab-growth">
        <GrowthTab :group-id="groupId" />
      </f7-tab>
      <f7-tab id="tab-calendar">
        <f7-page>
          <CalendarView :group-id="groupId" />
        </f7-page>
      </f7-tab>
      <f7-tab id="tab-marketplace">
        <f7-page>
          <MarketplaceView :group-id="groupId" />
        </f7-page>
      </f7-tab>
      <f7-tab id="tab-chat" @tab:show="chatTabActive = true" @tab:hide="chatTabActive = false">
        <TamtamMessage :f7route="tamtamRoute" :f7router="f7router" />
      </f7-tab>
      <f7-tab id="tab-docs">
        <f7-page>
          <DocumenTab :group-id="groupId" />
        </f7-page>
      </f7-tab>
    </f7-tabs>
  </f7-page>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { f7 } from 'framework7-vue'
import { useGroupsStore } from '../js/pinia-stores/group.js'
import AvocashCampaignList from './avocashCampaignList.vue'
import GroupHomeTab from '../components/group/GroupHomeTab.vue'
import MembersTab from '../components/group/MembersTab.vue'
import GrowthTab from '../components/group/GrowthTab.vue'
import CalendarView from '../components/group/CalendarView.vue'
import MarketplaceView from '../components/marketplace/MarketplaceView.vue'
import TamtamMessage from './tamtamMessage.vue'
import DocumenTab from './avocashGroupDocuments.vue'

const props = defineProps({
  groupId: { type: String, required: true },
  f7router: Object,
})

const store = useGroupsStore()
const group = ref(null)
const chatTabActive = ref(false)

const tamtamRoute = computed(() => ({
  path: `/group/message/${props.groupId}/GROUP`,
  url: `/group/message/${props.groupId}/GROUP`,
  params: { id: props.groupId, type: 'GROUP' },
}))

onMounted(async () => {
  await store.fetchGroupDetail(props.groupId)
  group.value = store.activeGroup
})

function navigateToMembers() {
  f7.views.main.router.navigate(`/groups/${props.groupId}/members`, {
    props: { groupName: group.value?.name || '' },
  })
}
</script>

<style scoped>
</style>
